import { Flex, Grid, Button } from '@mantine/core';
import FilterControls from './components/filterControls';
import WorkflowTable from './table';
import { useSelector } from 'react-redux';
import { getPermissions } from '../../store/profile.slice';
import { useNavigate } from 'react-router-dom';
import { WorkflowWrapper } from './styles';
import { ReactComponent as Way1 } from '../../assets/images/svg/way1.svg';
import { ReactComponent as Way2 } from '../../assets/images/svg/way2.svg';
import { ReactComponent as Way3 } from '../../assets/images/svg/way3.svg';
import { ReactComponent as Arrow } from '../../assets/images/svg/arrow-side.svg';
import { useIntl } from 'react-intl';
import { useFeatureGate } from '../../hooks/useFeatureGate';
import { FeaturePreview } from '../../components/FeaturePreview';
import { theme } from '@jadwalh/ui';
import { useState } from 'react';
import AddWorkflowModal from './addWorkflow';

export default function Workflow() {
  const permissions = useSelector(getPermissions);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const { isBlocked } = useFeatureGate('can_use_workflows');
  const [openWorkflowModel, setOpenWorkflowModel] = useState<boolean>(false);

  return (
    <WorkflowWrapper>
      <FeaturePreview
        isBlocked={isBlocked}
        title="سير العمل غير متاح في باقتك الحالية"
        description="يتيح لك سير العمل أتمتة خطوات الاجتماعات مثل الإشعارات والمتابعات، تُمكّنك من تنظيم عملياتك وتوفير وقت فريقك."
      >
        <Grid w={{sm: '100%', md: '60%'}} maw={1200} mx={'auto'} m={0} p={0} className="workflow-grid-container">
          <Grid.Col
            p={0}
            mt={{ base: '0', md: '8px' }}
            mb={{ base: '16px', md: '24px' }}
            mr="4px"
          >
            <Flex justify={'space-between'} align={'flex-start'}>
              <h2
                style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  fontFamily: theme.fonts.Bold,
                }}
              >
                {formatMessage({ id: 'workflows' })}
              </h2>
              {Array.isArray(permissions) &&
                permissions.includes('workflows.store') && (
                  <div className="action_container">
                    <Flex justify={'flex-end'} gap={'15px'}>
                      <Button
                        className="add"
                        onClick={() => setOpenWorkflowModel(true)}
                      >
                        {formatMessage({ id: 'add' })}
                      </Button>
                    </Flex>
                  </div>
                )}
            </Flex>
          </Grid.Col>
          <Grid.Col id="workflow_nav" className="workflow_nav" xs={12} p={0}>
            <FilterControls />
          </Grid.Col>
          <Grid.Col xs={12} p={0}>
            <WorkflowTable />
          </Grid.Col>
          {/* <Grid.Col md={12} my={{base:'16px', md:"24px"}} p={0}>
          <p
            style={{
              textAlign: 'center',
              color: '#303030',
              fontWeight: '400',
              lineHeight: '20px',
              fontSize: '14px',
            }}
          >
            {formatMessage({ id: 'startwithWay' })}
          </p>
        </Grid.Col>
        <Grid.Col md={12} p={0}>
          <Flex direction={{base:"column-reverse", md:"row"}} justify="center" gap={'16px'} align="stretch">
            <Flex className="way-container" p={'16px'} gap={'16px'} w={'100%'} style={{ flex: 1 }}>
              <Way1 />
              <Flex direction="column" style={{ flex: 1 }}>
                <h2>{formatMessage({ id: 'way1Title' })}</h2>
                <p>
                  {formatMessage({ id: 'way1Desc' })}
                </p>
                <p>
                  {formatMessage({ id: 'way1Desc2' })}
                </p>
              </Flex>
              <Arrow />
            </Flex>
            <Flex className="way-container" p={'16px'} gap={'16px'} w={'100%'} style={{ flex: 1 }}>
              <Way2 />
              <Flex direction="column" style={{ flex: 1 }}>
                <h2>{formatMessage({ id: 'way2Title' })}</h2>
                <p>
                  {formatMessage({ id: 'way2Desc' })}
                </p>
                <p>
                  {formatMessage({ id: 'way2Desc2' })}
                </p>
              </Flex>
              <Arrow />
            </Flex>
            <Flex className="way-container" p={'16px'} gap={'16px'} w={'100%'} style={{ flex: 1 }}>
              <Way3 />
              <Flex direction="column" style={{ flex: 1 }}>
                <h2>{formatMessage({ id: 'way3Title' })}</h2>
                <p>حدث يتم بين مضيف واحد ومدعو واحد</p>
                <p>
                  مثالي لمقابلات العمل، الجلسات الاستشارية، اجتماعات المتابعة،
                  أو أي لقاء بين شخصين.
                </p>
              </Flex>
              <Arrow />
            </Flex>
          </Flex>
        </Grid.Col> */}
        </Grid>
        {openWorkflowModel && (
          <AddWorkflowModal
            opened={openWorkflowModel}
            setOpened={setOpenWorkflowModel}
          />
        )}
      </FeaturePreview>
    </WorkflowWrapper>
  );
}
